import { VMain } from 'vuetify/lib/components/VMain';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VMain,{staticClass:"align-center"},[_c('div',{staticClass:"text-center"},[_c(VProgressCircular,{attrs:{"size":70,"width":7,"color":"blue darken-3","indeterminate":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }